<template>
<div>
  <div v-if="loading">
    {{ $t('loading')}}...
  </div>

  <div v-else>
    <NoData v-if="!hasData" />

    <div v-if='hasData' class="campaign-show">
      <div class="cockpit-header">

        <div class="gr">

          <div class="item">
            <div class="a">
              <svgicon name="car" color="#00b1eb" scale="1.5"></svgicon>
              <div>
                {{ $tc('campaigns.header',1) }}
              </div>
            </div>
            <div class="b">{{ campaign.name }}</div>
          </div>

        </div>
        <div class="gr gr-2x">

          <div class="item spaced">
            <div class="a">
              <svgicon name="contacts" color="#00b1eb" scale="1.5"></svgicon>
              <div>
                {{ $t('campaigns.duration') }}
              </div>
            </div>
            <div class="b">{{ durationHuman }}</div>
          </div>

          <div class="item spaced">
            <div class="a">
              <svgicon name="eye" color="#00b1eb" scale="1.5"></svgicon>
              <div>
                {{ $t('campaigns.city') }}
              </div>
            </div>
            <div class="b">{{ cities }}</div>
          </div>

        </div>
        <div class="gr gr-2x">

          <div class="item spaced">
            <div class="a">
              <svgicon name="money" color="#00b1eb" scale="1.5"></svgicon>
              <div>
                {{ $t('campaigns.budget') }}
              </div>
            </div>
            <div class="b">{{ campaign.budget.toLocaleString(lang,{ style: 'currency', currency: 'EUR',maximumFractionDigits: 0,minimumFractionDigits: 0 }) }}</div>
          </div>
          <div class="item spaced">
            <div class="a">
              <svgicon name="car" color="#00b1eb" scale="1.5"></svgicon>
              <div>
                {{ $t('campaigns.vehicles') }}
              </div>
            </div>
            <div class="b">{{ campaign.cars }}</div>
          </div>


        </div>

      </div>
      <div class="campaign-status" :class="statusClass">
        {{ $t('campaigns.status_label') }}: {{ statusLabel }}
      </div>

      <div class="campaign-body-row">
        <div class="item">
          <div class="item-content">
            <label>{{ $tc('campaigns.header',1) }}</label>
            <div class="item-label">{{ $t('campaigns.name') }}</div>
            <div class="item-value"> {{ campaign.name }}</div>
            <div class="item-label">{{ $t('campaigns.cust_detail') }}</div>
            <div class="item-value pre">{{ campaign.customer_detail }}</div>
            <div class="item-label">{{ $t('campaigns.created_on') }}</div>
            <div class="item-value"> {{ new Date(this.campaign.created).toLocaleDateString(lang,{timeZone: 'Europe/Vienna'}) }}</div>
            <div class="item-label">{{ $t('campaigns.created_by') }}</div>
            <div class="item-value"> {{ campaign.created_by }}</div>
          </div>
        </div>
        <div class="item item-2x">
          <div class="subitem">
            <div class="item-content">
              <div class="row">
                <div class="col-md-6" v-if='campaign.fleets[fleet]'>
                  <label>{{ $t('campaigns.vehicles') }}</label>
                  <div class="item-label">{{ $t('campaigns.fleet') }}</div>
                  <div class="item-value">{{ campaign.fleets[fleet]?campaign.fleets[fleet].class  :null }}</div>
                  <div class="item-label">{{ $t('campaigns.vehicles') }}</div>
                  <div class="item-value">{{ campaign.fleets[fleet].cars }}x {{foilDetail}}</div>
                  <div class="item-label">{{ campaign.fleets[fleet] ? campaign.fleets[fleet].class : null}}</div>
                  <div class="item-value">{{ campaign.fleets[fleet].detail }}</div>
                </div>
                <div class="col-md-6" v-if='campaign.fleets[fleet]'>
                  <div class="fleet-preview">
                    <i class="fa fa-chevron-left" aria-hidden="true" @click='fleet_pointer--'></i>
                    <img :src="campaign.fleets[fleet].cover_thumb" class="img-responsive" height='30px'>
                    <i class="fa fa-chevron-right" aria-hidden="true" @click='fleet_pointer++'></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="subitem">
            <div class="item-content">

              <label>{{$t('campaigns.addons.title')}}</label>
              <div class="addons">
                <div class="row">
                  <div class="col-xs-6" :class="{'disabled': !campaign.meta || campaign.meta.carmob != 1 }">
                    <div class="item-label"><i class="fa fa-fw" aria-hidden="true" :class="{'fa-square': campaign.meta && campaign.meta.carmob == 1, 'fa fa-square-o': !campaign.meta || campaign.meta.carmob != 1}"></i> {{ $t('campaigns.addons.carmob.title') }}</div>
                    <div class="item-value">{{$t('campaigns.addons.carmob.desc')}}</div>
                  </div>
                  <div class="col-xs-6" :class="{'disabled': !campaign.meta || campaign.meta.retarget != 1 }">
                    <div class="item-label"><i class="fa fa-fw" aria-hidden="true" :class="{'fa-square':campaign.meta && campaign.meta.retarget == 1, 'fa fa-square-o': !campaign.meta || campaign.meta.retarget != 1}"></i> {{ $t('campaigns.addons.retargeting.title') }}</div>
                    <div class="item-value">{{$t('campaigns.addons.retargeting.desc')}}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-6" :class="{'disabled': !campaign.meta || campaign.meta.incar != 1}">
                    <div class="item-label"><i class="fa fa-fw" aria-hidden="true" :class="{'fa-square':campaign.meta && campaign.meta.incar == 1, 'fa fa-square-o': !campaign.meta || campaign.meta.incar != 1}"></i> {{ $t('campaigns.addons.incar.title') }}</div>
                    <div class="item-value">{{$t('campaigns.addons.incar.desc')}}</div>
                  </div>
                  <div class="col-xs-6" :class="{'disabled': !campaign.meta || campaign.meta.layout != 1}">
                    <div class="item-label"><i class="fa fa-fw" aria-hidden="true" :class="{'fa-square':campaign.meta && campaign.meta.layout == 1, 'fa fa-square-o': !campaign.meta || campaign.meta.layout != 1}"></i> {{ $t('campaigns.addons.layout.title') }}</div>
                    <div class="item-value">{{$t('campaigns.addons.layout.desc')}}</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="item  item-2x">
          <div class="item-content" v-if="campaign.zones.length">
            <label>{{$t('campaigns.location')}}</label>
            <div class="row">
              <div class="col-md-4">
                <div class="item-label">{{$t('campaigns.zone')}}</div>
                <div class="item-value">{{ campaign.zones.length? campaign.zones[zone].gz.label:'' }}</div>
                <div class="item-label">{{$t('campaigns.duration')}}</div>
                <div class="item-value">{{ durationLabel }}<br>({{ durationHuman }})</div>
                <div class="item-label">{{$t('campaigns.timezone')}}</div>
                <div class="item-value">{{ campaign.zones.length? campaign.zones[zone].tz.label: '' }}</div>
              </div>
              <div class="col-md-8 zone-preview">
                <i class="fa fa-chevron-left" aria-hidden="true" @click="zone_pointer--"></i>
                <a :href=" campaign.zones.length? campaign.zones[zone].gz.thumb: ''" target="_blank">
                  <img :src=" campaign.zones.length? campaign.zones[zone].gz.thumb: ''" class="geozone img-responsive">
                </a>
                <i class="fa fa-chevron-right" aria-hidden="true" @click="zone_pointer++"></i>
              </div>
            </div>
            <img :src="campaign.zones.length? campaign.zones[zone].tz.thumb:''" alt="" class="img-responsive timezone">

          </div>
        </div>
      </div>
    </div>


  </div>

</div>
</template>

<script>
import NoData from './NoData.vue'
import moment from 'moment'
import 'moment/locale/en-gb'
import 'moment/locale/de'

import api from '../api'

import {
  mapState
} from 'vuex'
import '../icons'

export default {
  name: 'Campaign',
  components: {NoData},
  data () {
    return {
      campaign: null,
      fleet_pointer: 0,
      zone_pointer: 0,
      loading: true,
      hasData: true
    }
  },
  created () {
    var self = this
    var campaignID = self.$route.params.campaignID
    self.loading = true
    self.$Progress.set(25)
    api.getCampaign(campaignID)
      .then((r) => {
        self.campaign = r.data.data
        self.loading = false
        self.$Progress.finish()
        self.hasData = true
      })
      .catch(
        (e) => {
          self.$Progress.fail()
          self.hasData = false
          self.loading = false
        }
      )
  },
  computed: {
    cities () {
      if ('zones' in this.campaign) {
        let zones = this.campaign.zones
        return zones.map(i => i.gz.label).join(', ')
      }
      return ''
    },
    durationHuman () {
      moment.locale(this.lang)

      var start = new Date(this.campaign.start)
      var end = new Date(this.campaign.end)
      var diff = moment(start).from(moment(end).add(1, 'days'), true)
      return diff
    },
    durationLabel () {
      var start = new Date(this.campaign.start)
      var end = new Date(this.campaign.end)
      var options = {
        timeZone: 'Europe/Vienna'
      }
      return start.toLocaleDateString(this.lang, options) + ' - ' + end.toLocaleDateString(this.lang, options)
    },
    statusLabel () {
      return this.$t(`campaigns.statuses.${this.campaign.status}`)
    },
    statusClass () {
      return ['gray',
        'orange',
        'green',
        'blue'
      ][this.campaign.status]
    },
    foilDetail () {
      return {
        'P': 'Partial',
        'F': 'Full'
      }[this.campaign.fleets[this.fleet].foiling]
    },
    zone () {
      return Math.abs(this.zone_pointer % this.campaign.zones.length)
    },
    fleet () {
      return Math.abs(this.fleet_pointer % this.campaign.fleets.length)
    },
    ...mapState(['lang'])
  },
  methods: {
    addOnClass (addon) {
      var self = this
      return self.campaign.addons.includes(addon)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" src="../styles/_CampaignShow.styl"/>



// WEBPACK FOOTER //
// src/components/Campaign.vue